import { useCallback } from "react";
import type { MouseEvent } from "react";
import { MediaUIEvents } from "media-chrome/dist/constants.js";

interface UseVideoFullscreenParams {
  controller: HTMLElement | null;
  dispatchMediaEvent: (eventName: string) => void;
}

export const useVideoFullscreen = ({
  controller,
  dispatchMediaEvent,
}: UseVideoFullscreenParams) => {
  const handleVideoClick = useCallback(
    (event: MouseEvent<HTMLVideoElement>) => {
      if (event.detail !== 2 || !controller) {
        return;
      }

      const isFullscreen = controller.hasAttribute("mediaisfullscreen");

      dispatchMediaEvent(
        isFullscreen
          ? MediaUIEvents.MEDIA_EXIT_FULLSCREEN_REQUEST
          : MediaUIEvents.MEDIA_ENTER_FULLSCREEN_REQUEST,
      );
    },
    [controller, dispatchMediaEvent],
  );

  return { handleVideoClick };
};
